import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationStore = defineStore('notification', () => {
    const notifications = ref([]);
    const banners = ref([]);

    /**
     * @param {Object} notification
     * @param {string} notification.message
     * @param {string} notification.type - 'success' | 'error' | 'info'
     * @param {number} notification.duration - duration in ms, default 4500
     */
    const addNotification = ({ message, type = 'info', duration = 4500 }) => {
        const id = Date.now();
        notifications.value.push({ id, message, type });

        if (duration > 0) {
            setTimeout(() => {
                removeNotification(id);
            }, duration);
        }
    };

    /**
     * @param {Object} banner
     * @param {string} banner.message
     * @param {string} banner.type - 'warning' | 'error' | 'info'
     * @param {Object} banner.button
     * @param {string} banner.button.text
     * @param {Function} banner.button.action
     */
    const addBanner = ({ id, message, type = 'info', button }) => {
        if (id && banners.value.some(b => b.id === id)) {
            return id;
        }
        const bannerId = id || (Date.now() + Math.random());
        banners.value.push({ id: bannerId, message, type, button });
        return bannerId;
    };

    const removeBanner = (id) => {
        banners.value = banners.value.filter(b => b.id !== id);
    };

    const clearBanners = () => {
        banners.value = [];
    };

    const removeNotification = (id) => {
        notifications.value = notifications.value.filter(n => n.id !== id);
    };

    return {
        notifications,
        banners,
        addNotification,
        addBanner,
        removeNotification,
        removeBanner,
        clearBanners
    };
});
